import React from 'react'

export interface ILocalizationContext {
  getString: (key: string, locale: string) => string
  setLocalization: (langs: Record<string, Record<string, string>>) => void
}

const Ctx = React.createContext<ILocalizationContext>({
  getString: (key, locale) => key,
  setLocalization: () => undefined
})

export default Ctx
